import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import toast from 'react-hot-toast';

import { Box, Button } from '@mui/material';
import { Paragraph } from 'components/Typography';

let versionMatch: boolean = true;
let frontendVersion: string | undefined;

const axiosInstance = axios.create();
axiosInstance.interceptors.request.use(
    (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig | Promise<InternalAxiosRequestConfig> => {
        if (!versionMatch) {
            return new Promise(() => {});
        }
        const r: InternalAxiosRequestConfig = config;
        r.headers.Authorization = `Bearer ${localStorage.getItem(`sid`) ?? `  `}`;
        return r;
    },
    (error: AxiosError) => Promise.reject(error)
);
axiosInstance.interceptors.response.use(
    (response: AxiosResponse): AxiosResponse => {
        const version: string | undefined = response.headers[`x-frontend-version`] as string | undefined;
        if (!frontendVersion) {
            frontendVersion = version;
        }
        if (version !== frontendVersion && versionMatch) {
            versionMatch = false;
            toast.custom(
                () => (
                    <Box
                        sx={{
                            display: `flex`,
                            alignItems: `center`,
                            background: `#99CCFF`,
                            color: `#363636`,
                            lineHeight: `1.3`,
                            willChange: `transform`,
                            boxShadow: `0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)`,
                            maxWidth: `550px`,
                            pointerEvents: `auto`,
                            padding: `8px 10px`,
                            marginRight: `10px`,
                            borderRadius: `8px`,
                        }}
                    >
                        <Paragraph>
                            This application has been updated. Please refresh the page to get the latest version.
                        </Paragraph>
                        <Button sx={{ background: `#FFF` }} variant="outlined" onClick={() => window.location.reload()}>
                            Refresh
                        </Button>
                    </Box>
                ),
                { duration: 999999, position: `top-center` }
            );
        }

        return response;
    },
    (error: AxiosError) => {
        if (error?.response?.status === 401) {
            localStorage.removeItem(`sid`);
            window.location.href = `/login`;
        }
        return Promise.reject(error);
    }
);
export default axiosInstance;
